<template>
  <div class="solgt-com-banner">
    <div class="solgt-com-banner__content">
      <div class="solgt-com-banner__text">
        <p>
          Få et gratis og uforpligtende tilbud på din bil indenfor 24 timer med
          Solgt.com.
        </p>
        <p>
          Vi garanterer et salg og pengene på din konto indenfor 3 hverdage
          efter handel.
        </p>
      </div>
      <div class="solgt-com-banner__bottom-bar">
        <div class="solgt-com-banner__logo-container">
          <div class="solgt-com-banner__logo"></div>
        </div>
        <a
          class="button solgt-com-banner__button"
          href="https://solgt.com?utm_source=biltorvet&utm_medium=cpc&utm_campaign=biltorvet_leads"
          target="_blank"
          rel="noreferrer noopener"
          v-on:click="clicked"
        >
          Få tilbud
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {
  LogSolgtComMyAdsShown,
  LogSolgtComCreateShown,
  LogSolgtComMyAdsClicked,
  LogSolgtComCreateClicked,
} from '@/events'

export default {
  props: {
    location: { default: '', type: String },
  },
  methods: {
    clicked() {
      if (this.location === 'MyAds') {
        LogSolgtComMyAdsClicked()
      } else if (this.location === 'Create') {
        LogSolgtComCreateClicked()
      }
    },
    shown() {
      if (this.location === 'MyAds') {
        LogSolgtComMyAdsShown()
      } else if (this.location === 'Create') {
        LogSolgtComCreateShown()
      }
    },
  },
  mounted() {
    this.shown()
  },
}
</script>

<style lang="scss">
@import 'SolgtComBanner.scss';
</style>
